import React from "react";
import { DWChannelStatusInfo } from "landings/V2/USDDW/types";

export const USDDWContext = React.createContext<{ channelStatusInfo?: DWChannelStatusInfo }>({ channelStatusInfo: undefined });
